import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

const AnimatedLinearProgress = ({ percentage, date }) => {
  const rawValue = useMotionValue(0);
  const animatedValue = useSpring(rawValue, { stiffness: 100, damping: 20 });

  const percentDisplay = useTransform(
    animatedValue,
    (v) => `${Math.round(v)}%`
  );
  const widthValue = useTransform(animatedValue, (v) => `${v}%`);

  // Dynamically update the value when percentage changes
  React.useEffect(() => {
    rawValue.set(percentage);
  }, [percentage, rawValue]);

  // Dynamic color based on value
  const barColor = useTransform(animatedValue, (v) => {
    if (v <= 25) return "#f44336"; // red
    if (v <= 75) return "#ff9800"; // yellow/orange
    return "#4caf50"; // green
  });

  return (
    <Box sx={{ width: "100%" }}>
      {/* Top Row: Date and Percentage */}

      {/* Progress Container */}
      <Box sx={{ display: "flex", flexDirection: "row", gap: 0.5 }}>
        <Box
          component={motion.div}
          sx={{
            width: "100%",
            height: 7,
            borderRadius: 5,
            backgroundColor: "#e0e0e0",
            overflow: "hidden",
          }}
        >
          <motion.div
            style={{
              height: 7,
              width: widthValue,
              backgroundColor: barColor,
              borderRadius: 5,
            }}
          />
        </Box>
        <motion.div
          style={{
            fontSize: "0.700rem",
            fontWeight: 600,
            position: "relative",
            top: "-5px", // adjust value as needed
          }}
        >
          {percentDisplay || "0%"}
        </motion.div>
      </Box>
    </Box>
  );
};

export default AnimatedLinearProgress;
